import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {document} from 'ngx-bootstrap/utils';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {DeclaracaoSaudeColaboradorViewModel} from 'src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudeColaboradorVM';
import {ModuloPermissoesService} from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {ExportarTabelaService} from 'src/app/api/module/erp/services/exportarTabela/exportar-tabela.service';
import {Modulo} from 'src/app/api/module/erp/shared/enumerable/modulos';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {SubModuloNome} from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {TipoDocumentoExportarComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-documento-exportar-enum';
import {TipoPropostaEnumDescription} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import {AtualizacaoForcadaService} from 'src/app/api/module/erp/shared/services/atualizacao-forcada-service.service';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {TabNavigationService} from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import {DecalaracaoSaudePropostaService} from 'src/app/api/module/externo/services/proposta/declaracao-saude.proposta.service';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';
import {PerguntasDeclaracaoSaudeComponent} from '../perguntas-declaracao-saude/perguntas-declaracao-saude.component';

interface Resposta {
  codeQuestion: string;
  dependentProposalId?: string;
  holderProposalId?: string;
  obsGs?: string;
  response?: boolean;
  respostaColaborador?: boolean;
  pergunta?: string;
}

@Component({
  selector: 'app-proposta-declaracao-saude-colaborador',
  templateUrl: './proposta-declaracao-saude-colaborador.component.html',
  styleUrls: ['./proposta-declaracao-saude-colaborador.component.scss'],
})
export class PropostaDeclaracaoSaudeColaboradorComponent implements OnInit, AfterViewInit {
  @ViewChild(PerguntasDeclaracaoSaudeComponent)
  _perguntasDeclaracaoSaudeComponent!: PerguntasDeclaracaoSaudeComponent;

  activeTab: string = '';
  isLinear: boolean = false;
  showAlertMessageDependente: boolean = false;
  listaBeneficiariosDependentes = new Array<any>();
  listaRespostasTitular = new Array<any>() as any[];
  nomeTitular!: string;
  cpfTitular!: string;
  idTitular!: string;
  obsGsTitular!: string;
  dataDeNascimentoTitular!: string;
  estadoCivilTitular!: string;
  idProposta!: string;
  questionarioColaboradorParaEnviar!: DeclaracaoSaudeColaboradorViewModel;
  dependenteValido: {[key: string]: boolean} = {};
  ehValido: boolean = false;
  accordionAberto: number | null = null;
  openDependentId: string | null = null;
  hideCloseButton = false;
  sizeModal: any = 'modal-dialog';
  titleModal: any = 'Exportar Dados';
  idModal: any = 'exportarDados';
  tipoDocExportar = TipoDocumentoExportarComponent.getApenasPlanilhas();
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  formGrupRespostaQuestionario!: FormGroup;
  listaParaExportarDados = new Array<any>();
  listaFinal: {
    titular: {[key: string]: Resposta};
    dependentes: {[key: string]: {[key: string]: Resposta}};
  } = {
    titular: {},
    dependentes: {},
  };
  dependentInclusion: boolean | null = null;
  abaDependenteTocada: boolean = false;
  stepAtual!: number;
  propostaEnum = PropostaExternaEnum;
  mostrarAbaDependente: boolean = true;
  tipoPropostaTitular: TipoPropostaEnumDescription;

  constructor(
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _decalaracaoSaudePropostaService: DecalaracaoSaudePropostaService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private tabService: TabNavigationService,
    private formBuilder: FormBuilder,
    private _exportarTabelaService: ExportarTabelaService,
    private _scrollService: ScrollService,
    private cdRef: ChangeDetectorRef,
    private sesssaoService: jwtAuthService,
    private moduloPermissoesService: ModuloPermissoesService,
  ) {}

  get heColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  ngOnInit(): void {
    if (this.heColaborador && !this.sesssaoService.isUsuarioLogado()) {
      this._router.navigate(['/login']);
      this.toastr.warning('Favor, realizar o login!');
    } else {
      this.criarFormExportarQuerstionario();
      this.obterIDdaUrl();
    }
  }

  ngAfterViewInit(): void {
    this.buscarRespostasBeneficiario(this.idProposta);
  }

  iniciarSpinner() {
    this.spinner.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.spinner.hide();
        resolve(true);
      }, ms);
    });
  }

  obterIDdaUrl() {
    this._activeRoute.paramMap.subscribe((params: any) => {
      this.idProposta = params.get('idProposta');
    });
  }

  ativarAbaDependente() {
    if (this.dependentInclusion) {
      this.abaDependenteTocada = true;
      this.activeTab = 'dependente';

      setTimeout(() => {
        const tabElement = document.getElementById('aba-depente');
        if (tabElement) {
          tabElement.click();
        }
      }, 0);
    } else {
      this.activeTab = 'titular';
    }
  }

  buscarRespostasBeneficiario(idBeneficiario: string) {
    //this.iniciarSpinner();
    this._decalaracaoSaudePropostaService
      .buscarBeneficiarioParaOColaborador(idBeneficiario)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe((data: any) => {
        if (data.step == PropostaExternaEnum.VIDEO_CONFERENCIA) {
          this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.CARTA_ORIENTACAO);
        }
        this.stepAtual = data.step;
        this.nomeTitular = data?.holderProposal?.name;
        this.cpfTitular = data?.holderProposal?.cpf;
        this.idTitular = data?.holderProposal?.id;
        this.dataDeNascimentoTitular = data?.holderProposal?.birthDate;
        this.estadoCivilTitular = data?.holderProposal?.civilStatus?.name;
        this.tipoPropostaTitular = data?.proposalType;

        this.listaRespostasTitular = data?.holderProposal?.healthQuestionProposal;

        this.listaFinal.titular = data?.holderProposal?.healthQuestionProposal;
        this.listaFinal.titular = {};

        this.listaBeneficiariosDependentes = data?.holderProposal?.dependentsProposal;

        this.dependentInclusion = data.dependentInclusion;

        // Forçar detecção de mudanças antes de ativar a aba
        this.cdRef.detectChanges();
        setTimeout(() => {
          this.ativarAbaDependente();
        });

        this.listaRespostasTitular.forEach((item: any) => {
          this.listaFinal.titular[item.codeQuestion] = {
            codeQuestion: item.codeQuestion,
            holderProposalId: this.idTitular,
            response: item.response,
            respostaColaborador: item.respostaColaborador,
            ...item,
          };
        });
        this.mostrarAbaDependente = this.listaBeneficiariosDependentes?.length > 0 ? true : false;

        this.listaFinal.dependentes = {};
        this.listaBeneficiariosDependentes.forEach((dependente: any) => {
          this.listaFinal.dependentes[dependente.id] = {};
          (dependente.healthQuestionProposal || []).forEach((item: any) => {
            this.listaFinal.dependentes[dependente.id][item.codeQuestion] = {
              codeQuestion: item.codeQuestion,
              dependentProposalId: dependente.id,
              holderProposalId: this.idTitular,
              response: item.response,
              respostaColaborador: item.respostaColaborador,
              ...item,
            };
          });
        });
        this._perguntasDeclaracaoSaudeComponent &&
          this._perguntasDeclaracaoSaudeComponent.buscarPerguntasColaborador(
            this.listaRespostasTitular,
            data?.holderProposal?.obsGs,
          );
      });
    return;
  }

  respostasDosDependentes(idDependente: string) {
    this.listaBeneficiariosDependentes.find((dependente: any) => {
      if (dependente.id === idDependente) {
        const respostasDependente = this.listaFinal.dependentes[idDependente] || {};

        const respostasArray = Object.values(respostasDependente).filter(
          (resposta): resposta is Resposta => resposta !== null && resposta !== undefined,
        );

        const obsGs = (this.listaFinal.dependentes[idDependente] as any)?.['obsGs'] || dependente.obsGs;

        const dados = {
          questionario: respostasArray,
          campoObsGs: obsGs,
        };

        this.enviarDados([dados]);
        this.forcarAtualizacaoGrid();
      }
    });
  }
  enviarListaTitular() {
    const respostasTitular = Object.values(this.listaFinal.titular);
    const respostasFiltradas = respostasTitular.filter(resposta => resposta !== null && resposta !== undefined);
    this._perguntasDeclaracaoSaudeComponent.buscarPerguntasColaborador(respostasFiltradas, this.obsGsTitular);
  }

  enviarDados(data: any) {
    this._compartilharDadosEntreComponentsService.enviarDadosParaOutroComponent(data);
  }

  forcarAtualizacaoGrid() {
    this._atualizacaoForcadaService.emitirAtualizacaoForcadaDSColaborador();
  }

  receberRespostaColaborador(item: any) {
    let respostaAtual = item;
    let ehDependente = respostaAtual.dependentProposalId || false;
    let codeQuestion = respostaAtual.codeQuestion;

    if (!ehDependente) {
      if (this.listaFinal.titular[codeQuestion]) {
        this.listaFinal.titular[codeQuestion] = {
          ...this.listaFinal.titular[codeQuestion],
          ...respostaAtual,
        };
      } else {
        this.listaFinal.titular[codeQuestion] = respostaAtual;
      }

      if (!codeQuestion) {
        this.obsGsTitular = respostaAtual.obsGs;
      }
    } else {
      let dependenteId = respostaAtual.dependentProposalId as string;

      if (!this.listaFinal.dependentes[dependenteId]) {
        this.listaFinal.dependentes[dependenteId] = {};
      }

      if (codeQuestion) {
        if (this.listaFinal.dependentes[dependenteId][codeQuestion]) {
          this.listaFinal.dependentes[dependenteId][codeQuestion] = {
            ...this.listaFinal.dependentes[dependenteId][codeQuestion],
            ...respostaAtual,
          };
        } else {
          this.listaFinal.dependentes[dependenteId][codeQuestion] = respostaAtual;
        }
      } else {
        this.listaFinal.dependentes[dependenteId]['obsGs'] = respostaAtual.obsGs;
      }
    }
  }

  private scrollToAccordion(dependentId: string): void {
    const index = this.listaBeneficiariosDependentes.findIndex(d => d.id === dependentId);
    if (index >= 0) {
      setTimeout(() => {
        const element = document.getElementById(`colapseDependente${index}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 100);
    }
  }

  gotoTop() {
    this._scrollService.scrollToElement('#top-section', 140);
    this._scrollService.setStyle('#top-section', {
      'margin-top': '-141px !important',
    });
  }

  toggleDependent(dependentId: string): void {
    if (this.openDependentId === dependentId) {
      this.openDependentId = null;
    } else {
      this.openDependentId = dependentId;
      this.respostasDosDependentes(dependentId);
      this.scrollToAccordion(dependentId);
    }
  }

  getAccordionIcon(dependentId: string): string {
    return this.isDependentOpen(dependentId) ? 'fa-minus' : 'fa-plus';
  }

  isDependentOpen(dependentId: string): boolean {
    return this.openDependentId === dependentId;
  }

  colaboradorAvancar() {
    if (!this.podeCadastrarEditar) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }

    this.ehValido = false;
    this.iniciarSpinner();

    if (this.listaBeneficiariosDependentes.length > 0 && !this.abaDependenteTocada) {
      this.toastr.warning('Por favor, revise as informações dos dependentes antes de enviar.');
      this.pararSpinner();
      return;
    }

    if (!this.validarListaFinal()) {
      this.pararSpinner();
      return;
    }

    let listaRespostaColaboradorTitular: any[] = Object.values(this.listaFinal.titular);

    const perguntasEspecificasTitular = this.listaRespostasTitular.filter((item: any) =>
      [27, 28, 99].includes(item.codeQuestion),
    );

    listaRespostaColaboradorTitular = [
      ...listaRespostaColaboradorTitular,
      ...perguntasEspecificasTitular.filter(
        pergunta => !listaRespostaColaboradorTitular.some(item => item.codeQuestion === pergunta.codeQuestion),
      ),
    ];

    const dependentesProposal = this.listaBeneficiariosDependentes.map((dependente: any) => {
      const respostasDependentes = this.listaFinal.dependentes[dependente.id] || {};

      let respostasArray = Object.values(respostasDependentes).filter(item => item.codeQuestion);

      const obsGs = respostasDependentes['obsGs'] || dependente.obsGs;

      const perguntasEspecificasDependente =
        this.listaBeneficiariosDependentes &&
        this.listaBeneficiariosDependentes
          .filter((item: any) => item.id === dependente.id)
          .flatMap((item: any) => item.healthQuestionProposal || [])
          .filter((item: any) => [27, 28, 99].includes(item.codeQuestion));

      respostasArray = [
        ...respostasArray,
        ...perguntasEspecificasDependente.filter(
          pergunta => !respostasArray.some(item => item.codeQuestion === pergunta.codeQuestion),
        ),
      ];

      return {
        id: dependente.id,
        name: dependente.name,
        holderProposalId: dependente.holderProposalId,
        obsGs: obsGs,
        healthQuestionProposal: respostasArray,
      };
    });

    this.questionarioColaboradorParaEnviar = {
      id: this.idTitular,
      proposalId: this.idProposta,
      name: this.nomeTitular,
      cpf: this.cpfTitular,
      obsGs: this.obsGsTitular,
      healthQuestionProposal: listaRespostaColaboradorTitular,
      dependentsProposal: dependentesProposal,
    };
    this._decalaracaoSaudePropostaService
      .enviarQuestionarioColaborador(this.questionarioColaboradorParaEnviar)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: (data: any) => {
          if (data.proposal.step == PropostaExternaEnum.RETORNO_DS) {
            this.stepAtual = data.proposal.step;
            this.toastr.success('Questionários enviados com sucesso. O beneficiário será informado das alterações');
            this.cdRef.detectChanges();
          } else if (data.proposal.step == PropostaExternaEnum.PAGAMENTO) {
            this.toastr.success(
              'Questionários enviados com sucesso. O beneficiário será direcionado para etapa de pagamento',
            );
            this.recarregarRota(data);
          } else {
            this.toastr.success('Questionários enviados com sucesso.');
          }
          this.toastr.toastrConfig.preventDuplicates = true;
        },
        error: (error: any) => {
          this.toastr.error('Erro ao enviar o questionário');
          this.pararSpinner();
        },
      });
  }

  recarregarRota(dados: any) {
    const currentUrl = this._router.url;
    this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this._router.navigate([currentUrl]);
      setTimeout(() => {
        this.tabService.avancarParaProximaAba('pagamento');
        this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.PAGAMENTO);
        this.tabService.definirStepAtual(dados.proposal.step);
      }, 100);
    });
  }

  validarListaFinal(): boolean {
    this.ehValido = true;

    const eventoCompletoPreenchido = (response: any): boolean => {
      if (response.response !== true) return true;

      for (let i = 1; i <= 4; i++) {
        const dataEvento = response[`eventDate${i}`];
        if (dataEvento) {
          const campoObrigatorio = [`descriptionEvent${i}`, `cid${i}Id`, `cpt${i}`, `reason${i}`, `displayDs${i}`];

          const estaPreenchido = campoObrigatorio.every(campo => {
            const valor = response[campo];
            return valor !== undefined && valor !== null && valor !== '';
          });

          if (estaPreenchido) {
            return true;
          }
        }
      }
      return false;
    };

    // Validar evento titular se for nova adesao
    if (!this.dependentInclusion) {
      for (const [codeQuestion, response] of Object.entries(this.listaFinal.titular)) {
        if (response.response === true && !eventoCompletoPreenchido(response)) {
          if (response.pergunta) {
            this.toastr.warning(
              `Por favor, preencha todos campos do evento para o beneficiário ${this.nomeTitular} na pergunta: ${response.pergunta}`,
            );
          } else {
            this.toastr.warning(`Por favor, preencha o(s) evento(s) para o beneficiário ${this.nomeTitular}`);
          }
          return false;
        }
      }
    }

    // Validar evento dependente
    for (const dependente of this.listaBeneficiariosDependentes) {
      const dependenteId = dependente.id;

      const respostaDependente = this.listaFinal.dependentes[dependenteId] || {};

      for (const [codeQuestion, response] of Object.entries(respostaDependente)) {
        if (response.response === true && !eventoCompletoPreenchido(response)) {
          if (response.pergunta) {
            this.toastr.warning(
              `Por favor, preencha todos campos do evento para o beneficiário ${dependente.name} na pergunta: ${response.pergunta}`,
            );
          } else {
            this.toastr.warning(`Por favor, preencha o(s) evento(s) para o beneficiário ${dependente.name}`);
          }
          return false;
        }
      }
    }
    return true;
  }

  criarFormExportarQuerstionario() {
    this.formGrupRespostaQuestionario = this.formBuilder.group({
      typeExport: new FormControl(null, [Validators.required]),
    });
  }

  abrirModal() {
    this.isFormSubmited = false;
    this.formTouched = false;
    this.isFormSubmited = false;
    this.formTouched = false;
    this.titleModal = 'Exportar Dados';
    this.idModal = 'exportarTabela';
    this.sizeModal = 'modal-dialog';
  }

  fecharModal() {
    this._atualizacaoForcadaService.fecharModal();
    this.formGrupRespostaQuestionario.controls['typeExport'].reset();
    this.isFormSubmited = false;
    this.formTouched = false;
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formGrupRespostaQuestionario.valid;
  }

  async exportarDados() {
    this.isFormSubmited = true;
    this.formTouched = true;
    let tipo = this.formGrupRespostaQuestionario.controls['typeExport'].value + 1;
    this.listaParaExportarDados = [];
    let nomeTabela = '';
    const colunas = [
      {nome: 'Nome', campo: 'beneficiary'},
      {nome: 'Pergunta', campo: 'question'},
      {nome: 'Resposta', campo: 'response'},
      {nome: 'Data do Evento 1', campo: 'eventDate1'},
      {nome: 'Cid 1', campo: 'cid1'},
      {nome: 'Cumprir CPT 1', campo: 'cpt1'},
      {nome: 'Motivo 1', campo: 'reason1'},
      {nome: 'Exibir na DS 1', campo: 'displayDs1'},
      {nome: 'Especificação 1', campo: 'descriptionEvent1'},
      {nome: 'Data do Evento 2', campo: 'eventDate2'},
      {nome: 'Cid 2', campo: 'cid2'},
      {nome: 'Cumprir CPT 2', campo: 'cpt2'},
      {nome: 'Motivo 2', campo: 'reason2'},
      {nome: 'Exibir na DS 2', campo: 'displayDs2'},
      {nome: 'Especificação 2', campo: 'descriptionEvent2'},
      {nome: 'Data do Evento 3', campo: 'eventDate3'},
      {nome: 'Cid 3', campo: 'cid3'},
      {nome: 'Cumprir CPT 3', campo: 'cpt3'},
      {nome: 'Motivo 3', campo: 'reason3'},
      {nome: 'Exibir na DS 3', campo: 'displayDs3'},
      {nome: 'Especificação 3', campo: 'descriptionEvent3'},
      {nome: 'Data do Evento 4', campo: 'eventDate4'},
      {nome: 'Cid 4', campo: 'cid4'},
      {nome: 'Cumprir CPT 4', campo: 'cpt4'},
      {nome: 'Motivo 4', campo: 'reason4'},
      {nome: 'Exibir na DS 4', campo: 'displayDs4'},
      {nome: 'Especificação 4', campo: 'descriptionEvent4'},
      {nome: 'Altura', campo: 'height'},
      {nome: 'Peso', campo: 'weight'},
      {nome: 'Termo', campo: 'term'},
      {nome: 'Observação GS', campo: 'obs'},
    ];

    if (!this.isFormValid()) {
      const tipoDocumento = this.formGrupRespostaQuestionario.get('typeExport') as FormControl;

      tipoDocumento.markAsTouched();
      this.isFormSubmited = true;
      this.toastr.warning('Preencha o campo tipo para esportar o questionáiro.');
      return;
    }

    try {
      const data = await this._decalaracaoSaudePropostaService.exportarQuestionario(this.idProposta).toPromise();
      this.listaParaExportarDados = data && data;
      nomeTabela = 'Questionário DS';
      if (this.listaParaExportarDados) {
        this._exportarTabelaService.tipoDadoParaExportar(tipo, this.listaParaExportarDados, colunas, nomeTabela);
        this.fecharModal();
      }
    } catch (error) {
      this.toastr.warning('Questionário não encontrado.');
      console.error('Erro ao buscar questionário', error);
      this.fecharModal();
    }
  }

  get podeCadastrarEditar() {
    return this.moduloPermissoesService.permissaoCadastrarEditar(Modulo.CADASTROS, SubModuloNome.PROPOSTA_GESTAO_SAUDE);
  }

  receberDeclinio(stepDeclinado: number) {
    this.stepAtual = stepDeclinado || this.propostaEnum.PROPOSTA_DECLINADA;
  }
}
